import React from 'react';
import PropTypes from 'prop-types';
import { ListItemText, ListItem, List } from '@material-ui/core';
import { CURRENT_THEME } from '../../../../../config/index';
import { getRegionalColors } from '../../../../../utils/regional-colors';

const LeftDrawerSection = (props) => {
  const listClassName = `views-menu ${
    props.isMobileBrowser ? 'mobile-browser' : 'desktop-browser'
  }`;

  const currentTheme = CURRENT_THEME;

  const styles = {
    headerItem: {
      color: currentTheme.headerItemColor,
      fontSize: 14,
      boxShadow: currentTheme.headerItemBoxShadow,
      backgroundColor: getRegionalColors().backgroundColor,
      fontWeight: currentTheme.headerItemFontWeight
    },
    menuItem: {
      color: currentTheme.menuItemColor,
      backgroundColor: getRegionalColors().backgroundColor,
      fontSize: 14
    },
    selectedMenuListItem: {
      color: currentTheme.selectedMenuListItemColor,
      fontSize: 14,
      background: currentTheme.selectedMenuListItemBackgroundColor
    }
  };

  return (
    <List className={listClassName}>
      <List>
        {props.items.map((item, index) => (
          <ListItem
            key={item.id}
            button
            style={
              props.selectedIndex === item.id
                ? props.selectedItemStyle
                : styles.menuItem
            }
            className={`list-item views-menu ${
              props.isMobileBrowser ? 'mobile-browser' : 'desktop-browser'
            }`}
            onClick={item.onClick}
          >
            <ListItemText
              disableTypography
              className="menu-text-color"
              primary={item.text}
            />
          </ListItem>
        ))}
      </List>
    </List>
  );
};

LeftDrawerSection.propTypes = {
  selectedIndex: PropTypes.number,
  isMobileBrowser: PropTypes.bool,
  selectedItemStyle: PropTypes.object
};

export default LeftDrawerSection;
